import { render, staticRenderFns } from "./agv-customer-transactions-table.vue?vue&type=template&id=73ff23f8&scoped=true&lang=pug&"
import script from "./agv-customer-transactions-table.vue?vue&type=script&lang=js&"
export * from "./agv-customer-transactions-table.vue?vue&type=script&lang=js&"
import style0 from "./agv-customer-transactions-table.vue?vue&type=style&index=0&id=73ff23f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff23f8",
  null
  
)

export default component.exports